<script>
import { zendeskActions, zendeskValidateActions } from '@state/helpers'

import { mapState, mapGetters } from 'vuex'
import SubHeader from '@components/sub-header'

export default {
  name: 'TextArea',
  components: {
    SubHeader,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      textareaContent: '',
      textAreaMinLength: this.componentData.minLength > 0 ? this.componentData.minLength : 5,
    }
  },
  computed: {
    ...mapState('zendesk', {
      comment: state => state.common.comment,
    }),
    ...mapGetters('widgets', ['notSatisfiedUser']),
    isStillRequired () {
      return this.textareaContent.length >= this.textAreaMinLength
    },
    isNotRequired () {
      return this.textareaContent.length === this.textAreaMinLength - 1
    },
  },
  watch: {
    textareaContent () {
      const { minLength } = this.componentData
      this.commitZendeskCommon({
        key: 'comment',
        data: {
          body: this.textareaContent,
        },
      })

      this.commitCustomField({
        value: this.textareaContent,
        key: this.componentData.name,
      })

      if (this.isStillRequired) {
        this.commitValidatedField({
          type: 'function',
          key: 'commentValidation',
          name,
          value: this.textareaContent,
          message: this.$t('COMMON.MIN_CHARACTERS.BASE', {
            name,
            minLength,
          }),
        })
      } else if (this.isNotRequired) {
        this.removeValidatedField({ key: 'commentValidation' })
      }
    },
  },
  created () {
    this.textareaContent = this.comment ? this.comment.body : ''
    this.validateIfRequired()
  },
  methods: {
    ...zendeskActions,
    ...zendeskValidateActions,
    validateIfRequired () {
      const { name } = this.$options

      if (this.textAreaMinLength > 0) {
        this.commitRequiredFields({
          type: 'function',
          key: 'commentValidation',
          name,
          message: this.$t('COMMON.MIN_CHARACTERS.BASE', {
            name,
            minLength: this.textAreaMinLength,
          }),
        })
      }
    },
  },
}
</script>

<template>
  <div
    v-if="notSatisfiedUser"
    :class="$style.container"
  >
    <SubHeader :text="componentData.title" />

    <BaseTextarea
      :class="$style.container__textarea"
      v-model="textareaContent"
      :placeholder="componentData.placeHolder"
      class-style="default"
      rows="5"
      name="textareaContent"
    />
    <span
      v-if="!isStillRequired"
      :class="$style.container__textareaSpan"
    >{{ `min. ${textareaContent.length} / ${textAreaMinLength}` }}</span>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem 0;
  text-align: left !important;
  background-color: $background-container;

  &__textarea {
    margin-top: $size-spacing-medium;
    margin-bottom: 0.2rem;

    &Span {
      @extend %typography-small;
      align-self: flex-end;

      color: $cool-grey;
      margin: -0.3rem 1rem -0.3rem 0;
    }
  }
}
</style>
